import { useViewer } from '@/contexts/ViewerContext';
import { GameProvider, OrgEnum } from '@/globalTypes';
import { Nullable } from '@/types';

export type Operator = {
  name: string;
  path: string;
  id: OrgEnum;
  graphQLEndpoint: string;
  marketingAndFinanceEmbedUrl: Nullable<string>;
  rewardsGameProviders: GameProvider[];
  affiliateDomain?: string;
};

export const allOperators: Operator[] = [
  {
    name: 'Infiniza',
    path: 'infiniza',
    id: OrgEnum.IN,
    graphQLEndpoint: process.env.GATSBY_API_URL!,
    marketingAndFinanceEmbedUrl: process.env.GATSBY_MARKETING_LANDING_URL,
    rewardsGameProviders: [
      GameProvider.Evolution,
      GameProvider.Pragmatic,
      GameProvider.Relax,
      GameProvider.Hub88,
      GameProvider.PlayNGo,
      GameProvider.Elk,
      GameProvider.Fizzybubbly,
    ],
    affiliateDomain: '79affiliates.com',
  },
  {
    name: 'Frenwall',
    path: 'frenwall',
    id: OrgEnum.FW,
    graphQLEndpoint: process.env.GATSBY_API_URL!,
    marketingAndFinanceEmbedUrl: process.env.GATSBY_MARKETING_LANDING_URL,
    rewardsGameProviders: [
      GameProvider.Evolution,
      GameProvider.Pragmatic,
      GameProvider.Relax,
      GameProvider.Hub88,
      GameProvider.PlayNGo,
      GameProvider.Elk,
      GameProvider.Fizzybubbly,
      GameProvider.Gator,
    ],
    affiliateDomain: '79affiliates.com',
  },
  {
    name: 'Hundise',
    path: 'hundise',
    id: OrgEnum.HE,
    graphQLEndpoint: process.env.GATSBY_API_URL!,
    marketingAndFinanceEmbedUrl: process.env.GATSBY_MARKETING_LANDING_URL,
    rewardsGameProviders: [
      GameProvider.Pragmatic,
      GameProvider.Aleaplay,
      GameProvider.Hub88,
      GameProvider.Gator,
    ],
    affiliateDomain: '79affiliates.com',
  },
  {
    name: 'Elmst',
    path: 'elmst',
    id: OrgEnum.ELM,
    graphQLEndpoint: process.env.GATSBY_API_URL!,
    marketingAndFinanceEmbedUrl: process.env.GATSBY_MARKETING_LANDING_URL,
    rewardsGameProviders: [
      GameProvider.Evolution,
      GameProvider.Pragmatic,
      GameProvider.Relax,
      GameProvider.Hub88,
      GameProvider.PlayNGo,
      GameProvider.Elk,
      GameProvider.Fizzybubbly,
      GameProvider.Gator,
    ],
    affiliateDomain: '79affiliates.com',
  },
  {
    name: 'Elvel',
    path: 'elvel',
    id: OrgEnum.VEL,
    graphQLEndpoint: process.env.GATSBY_API_URL!,
    marketingAndFinanceEmbedUrl: process.env.GATSBY_MARKETING_LANDING_URL,
    rewardsGameProviders: [
      GameProvider.Pragmatic,
      GameProvider.Relax,
      GameProvider.Hub88,
      GameProvider.PlayNGo,
      GameProvider.Elk,
      GameProvider.Fizzybubbly,
      GameProvider.Gator,
    ],
    affiliateDomain: '79affiliates.com',
  },
  {
    name: 'Ludaro',
    path: 'ludaro',
    id: OrgEnum.IN,
    graphQLEndpoint: process.env.GATSBY_API_URL!,
    marketingAndFinanceEmbedUrl: process.env.GATSBY_MARKETING_LANDING_URL,
    rewardsGameProviders: [
      GameProvider.Pragmatic,
      GameProvider.Relax,
      GameProvider.Hub88,
      GameProvider.PlayNGo,
      GameProvider.Elk,
      GameProvider.Fizzybubbly,
      GameProvider.Gator,
    ],
    affiliateDomain: '79affiliates.com',
  },
  {
    name: 'Apexino',
    path: 'apexino',
    id: OrgEnum.APX,
    graphQLEndpoint: process.env.GATSBY_API_URL!,
    marketingAndFinanceEmbedUrl: process.env.GATSBY_MARKETING_LANDING_URL,
    rewardsGameProviders: [
      GameProvider.Pragmatic,
      GameProvider.Relax,
      GameProvider.Hub88,
      GameProvider.PlayNGo,
      GameProvider.Elk,
      GameProvider.Fizzybubbly,
      GameProvider.Gator,
    ],
    affiliateDomain: '79affiliates.com',
  },
];

export const operatorsById = allOperators.reduce(
  (acc, value) => {
    acc[value.id] = value;
    return acc;
  },
  {} as Record<OrgEnum, Operator>,
);

export const getOperatorFromEnv = () => {
  const operator = process.env.GATSBY_OPERATOR!;

  const foundOperator = allOperators.find((a) => a.path === operator);

  return foundOperator;
};

export const useOperators = () => {
  const { viewer } = useViewer();

  return allOperators.filter(
    (a) => viewer?.identity.orgs.includes(a.id) || false,
  );
};
